import React from 'react';
import { Stack, Card, Text } from '@chaser/components';
import useShortCode from '../../../../hooks/useShortCode';
import AccountingSoftware from './AccountingSoftware';
import OpenAPI from './OpenAPI/Index';
import useOrganisation from '../../../../hooks/useOrganisation';
import { Integrations as IntegrationList } from '../../../../util/constants';
import CustomInvoicePDFs from './CustomInvoicePDFs';
import CustomerRecipientsVisibleLabels from './CustomerRecipientsVisibleLabels';
import NetsuiteIntegrationDetails from './NetsuiteIntegrationDetails';

const Integrations = () => {
  const ShortCode = useShortCode();
  const { accountingSoftware, features } = useOrganisation();

  const isOpenApiCompatibleAccountingSoftware = [
    IntegrationList.OPENAPI,
    IntegrationList.SAGE200,
  ].includes(accountingSoftware);

  const isOpenApiEnabled = features.openapi;

  const displayOpenApi = isOpenApiCompatibleAccountingSoftware || isOpenApiEnabled;
  const isAccountsIQ = accountingSoftware === IntegrationList.ACCOUNTSIQ;
  const isOdoo = accountingSoftware === IntegrationList.ODOO;
  const isNetsuite = accountingSoftware === IntegrationList.NETSUITE;

  const options = [
    isAccountsIQ && <CustomInvoicePDFs key="custom-invoice-pdf" />,
    isOdoo && <CustomerRecipientsVisibleLabels key="customer-recipients-visible-labels" />,
    isNetsuite && <NetsuiteIntegrationDetails key="netsuite-integration-details" />,
  ].filter(Boolean);

  return (
    <Stack>
      <AccountingSoftware ShortCode={ShortCode} />
      {options.length > 0 && (
        <Card p="large">
          <Stack gap="medium">
            <Text fontWeight="Bold">Settings</Text>
            <Stack gap="medium">{options}</Stack>
          </Stack>
        </Card>
      )}
      {displayOpenApi && <OpenAPI ShortCode={ShortCode} />}
    </Stack>
  );
};

export default Integrations;
